$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});



$(document).on("click", ".custom_select_patterns_item", function(e) {
var current_tab = $(this).attr('current_tab');
$('.custom_popup').show();
$('.trigger_pattern_count').attr('current_tab',current_tab);
});


$(document).on("click", ".popup_product_flex_item:not(.active)", function(e) {
$('.custom_select_patterns_item').removeClass('free_product_lp');
var currency_symbol = $('.custom_popup').attr('currency');
var current_tab = $(this).parents('.trigger_pattern_count').attr('current_tab');
$('.popup_product_flex_item.active[active_tab="'+current_tab+'"]').removeClass('active');
$('.popup_product_flex_item.active[active_tab="'+current_tab+'"]').attr('active_tab','');
$(this).addClass('active');
$(this).attr('active_tab',current_tab);
var variant_id = $(this).attr('variant_id');
var price = $(this).attr('price');
var image = $(this).find('img').attr('src');
var title = $(this).find('.popup_product_flex_item_title').text();
$('.custom_popup').hide();
var price_no = (price/100).toFixed(2);
var price_currency = currency_symbol+ price_no;
var target_pattern = $('.custom_select_patterns_item[current_tab="'+current_tab+'"]');
target_pattern.attr('variant_id',variant_id);
target_pattern.attr('price',price);
target_pattern.addClass('active');
target_pattern.find('.custom_select_patterns_item_locked img').attr('src',image);
target_pattern.find('.custom_select_patterns_item_locked p.title').text(title);
target_pattern.find('.custom_select_patterns_item_locked p.price').text(price_currency);

var variant_id = $(this).attr('upsell_product_id');
var price = $(this).attr('upsell_price');
var image = $(this).attr('upsell_image');
var title = $(this).attr('upsell_title'); 
var target_pattern = $('.custom_select_patterns_item_upsell[current_tab="'+current_tab+'"]');
var price_no = (price/100).toFixed(2);
var price_currency = currency_symbol+ price_no;
target_pattern.attr('variant_id',variant_id);
target_pattern.attr('price',price);
target_pattern.addClass('active');
target_pattern.removeClass('added');
target_pattern.find('.custom_select_patterns_item_upsell_locked img').attr('src',image);
target_pattern.find('.custom_select_patterns_item_upsell_locked p.title').text(title);
target_pattern.find('.custom_select_patterns_item_upsell_locked p.price').text(price_currency);
update_price();
});


$(document).on("click", ".delete_pattern", function(e) {
$('.custom_select_patterns_item').removeClass('free_product_lp');
var current_tab = $(this).parents('.custom_popup').attr('current_tab');
$(this).parents('.custom_popup').find('.popup_product_flex_item[active_tab="'+current_tab+'"]').attr('active_tab','').removeClass('active');
$('.custom_popup').hide();
var target_pattern = $('.custom_select_patterns_item[current_tab="'+current_tab+'"]');
target_pattern.attr('variant_id','');
target_pattern.attr('price','');
target_pattern.removeClass('active');
target_pattern.find('.custom_select_patterns_item_locked img').attr('src','');
target_pattern.find('.custom_select_patterns_item_locked p.title').text('');
target_pattern.find('.custom_select_patterns_item_locked p.price').text('');



var target_pattern2 = $('.custom_select_patterns_item_upsell[current_tab="'+current_tab+'"]');
target_pattern2.attr('variant_id','');
target_pattern2.attr('price','');
target_pattern2.removeClass('active').removeClass('added');
target_pattern2.find('.custom_select_patterns_item_upsell_locked img').attr('src','');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.title').text('');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.price').text('');

if(current_tab<5){
for(var i = 5; i < 9; i++){
var target_pattern = $('.custom_select_patterns_item[current_tab="'+i+'"]');
target_pattern.attr('variant_id','');
target_pattern.attr('price','');
target_pattern.removeClass('active');
target_pattern.find('.custom_select_patterns_item_locked img').attr('src','');
target_pattern.find('.custom_select_patterns_item_locked p.title').text('');
target_pattern.find('.custom_select_patterns_item_locked p.price').text('');
var target_pattern2 = $('.custom_select_patterns_item_upsell[current_tab="'+i+'"]');
target_pattern2.attr('variant_id','');
target_pattern2.attr('price','');
target_pattern2.removeClass('active').removeClass('added');
target_pattern2.find('.custom_select_patterns_item_upsell_locked img').attr('src','');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.title').text('');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.price').text('');
}
}


  
update_price();
});

 

function update_price() {
var total_price = 0;
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
var active_patterns = $('.custom_select_patterns1 .custom_select_patterns_item.active').length;
var active_patterns2 = $('.custom_select_patterns2 .custom_select_patterns_item.active').length;
if (active_patterns>3 ){
var price_array = ','
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
price_array = price_array+','+price;
});

$('.custom_select_patterns_item_upsell.active.added').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
price_array = price_array.replace(",,", "");
price_array = price_array.split(",");
price_array = price_array.sort(function (a, b) { return a - b });
var lowest_price = price_array[0];
$('.custom_select_patterns_item').removeClass('free_product_lp');
$('.custom_select_patterns_item[price="'+lowest_price+'"]:not(.free_product_lp)').eq(0).addClass('free_product_lp');
var total_price =total_price-lowest_price;
} else {
$('.custom_select_patterns2 .custom_select_patterns_item.active').each(function(){
var current_tab = $(this).attr('current_tab');
$('.custom_popup').find('.popup_product_flex_item[active_tab="'+current_tab+'"]').attr('active_tab','').removeClass('active');
$(this).attr('variant_id','');
$(this).attr('price','');
$(this).removeClass('active');
$(this).find('.custom_select_patterns_item_locked img').attr('src','');
$(this).find('.custom_select_patterns_item_locked p').text('');
});
var total_price = 0;
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});

$('.custom_select_patterns_item_upsell.active.added').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
}


var total_patterns = active_patterns + active_patterns2; 
if (total_patterns == 8 ){
var total_price = 0;
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
var price_array = ','
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
price_array = price_array+','+price;
});

$('.custom_select_patterns_item_upsell.active.added').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
price_array = price_array.replace(",,", "");
price_array = price_array.split(",");
price_array = price_array.sort(function (a, b) { return a - b });
var lowest_price = price_array[0];
var lowest_price2 = price_array[1];
$('.custom_select_patterns_item').removeClass('free_product_lp');
$('.custom_select_patterns_item[price="'+lowest_price+'"]:not(.free_product_lp)').eq(0).addClass('free_product_lp');
$('.custom_select_patterns_item[price="'+lowest_price2+'"]:not(.free_product_lp)').eq(0).addClass('free_product_lp');
var total_price =total_price-lowest_price-lowest_price2;
}




  
var currency_symbol = $('.custom_popup').attr('currency');
var price_string = total_price/100;
var price_currency = currency_symbol+ price_string;
if(total_price > 0){
$('.new_price_trigger').text(price_currency).show();  
$('.old_price_trigger').hide(); 
$('.checkout_button_custom.button').removeAttr('disabled');
} else {
$('.new_price_trigger').text('').hide();  
$('.old_price_trigger').show(); 
$('.checkout_button_custom.button').attr('disabled','disabled');
}
$('.custom_select_patterns1').attr('active_patterns',active_patterns);
$('.custom_select_patterns2').attr('active_patterns',active_patterns2);
if (active_patterns==4 ){
$('.offer_text').hide();
$('.offer_text.active_all').show();
} else if (active_patterns==3 ){
$('.offer_text').hide();
$('.offer_text.active4').show();
}else if (active_patterns==2 ){
$('.offer_text').hide();
$('.offer_text.active3').show();
}else if (active_patterns==1 ){
$('.offer_text').hide();
$('.offer_text.active2').show();
}else if (active_patterns==0 ){
$('.offer_text').hide();
$('.offer_text.active1').show();
}
}



$(document).on("click", ".custom_additional_patterns", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().next().slideUp();
    jQuery(this).next().slideUp();
  } else {
    jQuery(this).toggleClass('active');
    jQuery(this).next().next().slideToggle({
  duration: 200,
  start: function() {
    jQuery(this).css('display','flex');
  }
});
    jQuery(this).next().slideToggle({
  duration: 200,
  start: function() {
    jQuery(this).css('display','flex');
  }
});
  }
});



$(document).on("click", ".add_custom_ajax_upsell", function (e) {
jQuery(this).parents('.custom_select_patterns_item_upsell').addClass('added');
update_price();
});

$(document).on("click", ".remove_custom_ajax_upsell", function (e) {
jQuery(this).parents('.custom_select_patterns_item_upsell').removeClass('added');
update_price();
});




$(document).on("click", ".custom_product_heading strong, .announcment_text strong, .free_bar .rich-text-new__richtext strong", function (e) {
applied();
});
$('.custom_product_heading strong').addClass('stop_click');
function applied() {

$('.custom_applied_text').css('display','flex');
$('.custom_applied_text').css('opacity','1');
setTimeout(function() {
$('.custom_applied_text').css('opacity','0');
}, 4500);
setTimeout(function() {
$('.custom_applied_text').css('display','none');
$('.custom_product_heading strong, .announcment_text strong, .free_bar .rich-text-new__richtext strong').removeClass('stop_click');
}, 5500);

}